import { useState, useEffect } from 'react'

import TokenHelper from 'common/helpers/token'

export default function useUser() {
  const [isLogged, setIsLogged] = useState(false)

  useEffect(() => {
    setIsLogged(TokenHelper.hasToken())
  }, [])

  return { isLogged }
}
